import type { BundleIdentification } from "./useBundlesForPatient";

export const fileCount = (count: number) => `${count} file${count === 1 ? "" : "s"}`;

export const identificationText = ({
  identified_type,
  confidence,
}: Pick<BundleIdentification, "identified_type" | "confidence">) => `${identified_type} (${confidence})`;

export function fileLabel(key: string): string {
  return key.split("/").pop() ?? key;
}
